import { connect } from 'react-redux';

import { beginChat } from 'app/modules/ui/actions';
import DeflectionPanel from 'presentation/components/__demo__/DeflectionPanel';

export const mapDispatchToProps = dispatch => {
  return {
    onClick: () => {
      dispatch(beginChat());
    },
  };
};

export const mapStateToProps = state => {
  return {};
};

const DeflectionPanelContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DeflectionPanel);

export default DeflectionPanelContainer;
